import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4b8a40e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row p-4 m-lg-0 justify-content-center bg-white rounded-4 shadow" }
const _hoisted_2 = { class: "fw-bold mb-5" }
const _hoisted_3 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_4 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_5 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_6 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_7 = { class: "col-lg-10 d-flex" }
const _hoisted_8 = { class: "form-check me-4 my-auto" }
const _hoisted_9 = {
  class: "form-check-label",
  for: "sendMessage"
}
const _hoisted_10 = { class: "form-check my-auto" }
const _hoisted_11 = {
  class: "form-check-label",
  for: "sendInfo"
}
const _hoisted_12 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_13 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_14 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_15 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_16 = { class: "col-lg-10" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_19 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_20 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_21 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_22 = { class: "col-lg-10" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_25 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_26 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_27 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_28 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_29 = { class: "col-lg-10" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_32 = { class: "mt-2 break-word" }
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = { class: "d-flex justify-content-center" }
const _hoisted_35 = {
  class: "modal fade",
  id: "createMessageTemplateSuccess",
  tabindex: "-1",
  "aria-labelledby": "createMessageTemplateSuccess",
  "aria-hidden": "true"
}
const _hoisted_36 = { class: "modal-dialog" }
const _hoisted_37 = { class: "modal-content" }
const _hoisted_38 = { class: "modal-header" }
const _hoisted_39 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "createMessageTemplateSuccess"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_41 = { class: "text-center mt-3" }
const _hoisted_42 = { class: "modal-footer d-flex justify-content-center" }

import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'

import CreateMessageTemplateModal from '@/views/community-admin/message-template/components/CreateMessageTemplateModal.vue'

//validate
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import useVuelidate from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import { customMaxLength, scrollToErrors } from '@/utils'
import Breadcrumb from '@/components/breadcrumb/index.vue'

//constant
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { REGEX_EMOJI } from '@/constants/regex'

import { computed, onMounted, ref, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import messageTemplateServices from '@/services/message-template.services'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const createFailed = ref(false)
const disabledButton = ref(false)
const route = useRoute()

const router = useRouter()
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route?.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('messageManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('CE10breadcrumb2'),
    to: `/community/communities/${route?.params?.id}/message_templates`,
    active: false,
  },
  {
    content: translate('createMessageTemplate'),
    to: '',
    active: true,
  },
]

const rules = computed(() => {
  return {
    message_type: {},
    name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 30),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    title: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 70),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    content: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 2000),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
      urlCannotBeUsed: function (value) {
        return !(value.includes('#グループ招待URL#') && formData.value.message_type === 0)
      },
      urlNotFound: function (value) {
        return !(!value.includes('#グループ招待URL#') && formData.value.message_type === 1)
      },
    },
  }
})

const formData = ref({
  message_type: 0,
  name: '',
  title: '',
  content: '',
})

const v$ = useVuelidate(rules, formData)
const loading = ref(false)

const typeInTextarea = (newText, el = document.getElementById('content')) => {
  const start = el.selectionStart
  const end = el.selectionEnd
  const text = el.value
  const before = text.substring(0, start)
  const after = text.substring(end, text.length)
  el.value = before + newText + after
  formData.value.content = before + newText + after
  el.selectionStart = el.selectionEnd = start + newText.length
  el.focus()
}

const onSubmit = async (): void => {
  v$.value.$touch()
  loading.value = true

  isCheckedNGKeyTitle.value = false
  isCheckedNGContent.value = false
  await checkNGTitle()
  await checkNGContent()
  while (!isCheckedNGKeyTitle.value || !isCheckedNGContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyTitle.value || ngKeyContent.value) {
    loading.value = false
    nextTick(() => {
      scrollToErrors()
    })
    return
  }
  modalCreateConfirm.value.show()
  loading.value = false
}

const onSubmitMessage = async (): void => {
  try {
    disabledButton.value = true
    if (route.params?.id) {
      const response = await messageTemplateServices.createMessageTemplates({ community_id: route.params?.id, data: formData.value })
      if (response?.status === 200) {
        createFailed.value = false
        modalCreateConfirm.value.hide()
        modalCreateFinish.value.show()
        disabledButton.value = false
      } else {
        modalCreateConfirm.value.hide()
        modalCreateFinish.value.show()
        createFailed.value = true
        disabledButton.value = false
      }
      v$.value.$reset()
      Object.assign(formData.value, {
        message_type: 0,
        name: '',
        title: '',
        content: '',
      })
    }
  } catch (error) {
    console.log(error)
    modalCreateConfirm.value.hide()
    modalCreateFinish.value.show()
    disabledButton.value = false
    createFailed.value = false
  }
}

const handleBack = (): void => {
  router.push(`/community/communities/${route.params.id}/message_templates`)
}

const isCheckedNGKeyTitle = { value: false }
const ngKeyTitle = ref<boolean>(false)
const checkNGTitle = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.title.$model })
  ngKeyTitle.value = data.data?.data?.has_ngword
  isCheckedNGKeyTitle.value = true
}, 200)

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
}, 200)

const modalCreateConfirm = ref()
const modalCreateFinish = ref()
onMounted(() => {
  modalCreateConfirm.value = new Modal(document.getElementById('confirmModal'))
  modalCreateFinish.value = new Modal(document.getElementById('createMessageTemplateSuccess'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('createMessageTemplate')), 1),
      _createElementVNode("form", {
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)('templateType')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault",
                    id: "sendMessage",
                    value: 0,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).message_type.$model) = $event))
                  }, null, 512), [
                    [_vModelRadio, _unref(v$).message_type.$model]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50sendAllMessages')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault",
                    id: "sendInfo",
                    value: 1,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).message_type.$model) = $event))
                  }, null, 512), [
                    [_vModelRadio, _unref(v$).message_type.$model]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('sendInviteOnlyGroupInfo')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('templateName')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "content",
                name: "name",
                class: _normalizeClass(['form-control', _unref(v$).name.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                placeholder: _unref(translate)('placeholder')
              }, null, 10, _hoisted_17), [
                [
                  _vModelText,
                  _unref(v$).name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('templateName'),
                params: [1, 30],
                validator: _unref(v$).name.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(translate)('title')), 1),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: "content",
                name: "title",
                class: _normalizeClass(['form-control', ngKeyTitle.value || _unref(v$).title.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).title.$model) = $event)),
                placeholder: _unref(translate)('placeholder'),
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(checkNGTitle) && _unref(checkNGTitle)(...args)))
              }, null, 42, _hoisted_23), [
                [
                  _vModelText,
                  _unref(v$).title.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyTitle.value && !_unref(v$).title.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('title'),
                params: [1, 70],
                validator: _unref(v$).title.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(translate)('content')), 1),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("textarea", {
                id: "content",
                name: "content",
                class: _normalizeClass(['form-control', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                rows: "10",
                placeholder: _unref(translate)('placeholder'),
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args)))
              }, null, 42, _hoisted_30), [
                [_vModelText, _unref(v$).content.$model]
              ]),
              (ngKeyContent.value && !_unref(v$).content.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('content'),
                params: [1, 2000],
                validator: _unref(v$).content.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ]),
            _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(translate)('CE10textarea') + '\n' + _unref(translate)('CE10textarea1')), 1),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", {
                class: "tag fs-8 d-flex align-items-center justify-content-center cursor-pointer bg-white",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (typeInTextarea('#姓#')))
              }, "#" + _toDisplayString(_unref(translate)('surName')) + "#", 1),
              _createElementVNode("div", {
                class: "tag ms-2 fs-8 d-flex align-items-center justify-content-center cursor-pointer",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (typeInTextarea('#名#')))
              }, "#" + _toDisplayString(_unref(translate)('name')) + "#", 1),
              (formData.value.message_type === 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "tag-big ms-2 fs-8 d-flex align-items-center justify-content-center cursor-pointer",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (typeInTextarea(`#${_unref(translate)('invitationGroupUrl')}#`)))
                  }, " #" + _toDisplayString(_unref(translate)('invitationGroupUrl')) + "# ", 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(Button, {
            title: _unref(translate)('back'),
            type: 'secondary',
            onClick: handleBack,
            className: 'fw-bold me-2'
          }, null, 8, ["title"]),
          _createVNode(Button, {
            title: _unref(translate)('confirm'),
            disabled: loading.value,
            loading: loading.value,
            onClick: onSubmit,
            className: 'fw-bold',
            type: 'secondary'
          }, null, 8, ["title", "disabled", "loading"])
        ])
      ], 32)
    ]),
    _createVNode(CreateMessageTemplateModal, {
      formData: formData.value,
      onSubmitMessage: onSubmitMessage,
      disabledButton: disabledButton.value
    }, null, 8, ["formData", "disabledButton"]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("h5", _hoisted_39, _toDisplayString(_unref(translate)('createMessageTemplate')), 1),
            _hoisted_40
          ]),
          _createElementVNode("p", _hoisted_41, _toDisplayString(createFailed.value ? _unref(translate)('registrationError') : _unref(translate)('registrationComplete')), 1),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})